import template from './reports-list.html';

class ReportsListController {
  constructor(reportingService) {
    'ngInject';

    this.reportingService = reportingService;
    this.status = '';
  }

  $onInit() {
    this.getSortedGroupedReports();
  }

  $onChanges() {}

  $onDestroy() {}

  getSortedGroupedReports() {
    this.status = 'loading';
    this.reportingService
      .getGroupedReports()
      .then((reports) => {
        this.status = '';
        this.groupedReports = reports;
      })
      .catch(() => {
        this.status = 'error';
      });
  }
}

export default {
  template,
  controller: ReportsListController,
  bindings: {},
};
